/* eslint-disable max-params */
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { SuggestionService } from '../suggestion-service';
import { SuggestionModel } from '../../models/suggestion-model';

@injectable()
export class SuggestionServiceImpl implements SuggestionService {

    constructor(
        @inject(SuggestionModel)
        private _model: SuggestionModel,
    ) {}

    public changeActiveSuggestionIdx (activeSuggestionIdx: number) {
        this._model.update(modelData => {
            modelData.activeSuggestionIdx = activeSuggestionIdx;
            return modelData;
        });
    }
}
